import { render, staticRenderFns } from "./hosCultureList.vue?vue&type=template&id=2f929c24&scoped=true&"
import script from "./hosCultureList.vue?vue&type=script&lang=js&"
export * from "./hosCultureList.vue?vue&type=script&lang=js&"
import style0 from "./hosCultureList.vue?vue&type=style&index=0&id=2f929c24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f929c24",
  null
  
)

export default component.exports